"use client";import{jsxs as e,jsx as t}from"react/jsx-runtime";import{twJoin as o}from"tailwind-merge";import"react";import{SystemIcon as s}from"../../DataDisplays/SystemIcon/SystemIcon.js";import"../../DataDisplays/SystemIcon/SystemIcon.constants.js";import"../../Base/Layouts/Box/Box.js";import"../../Base/Layouts/FullBleed/FullBleed.js";import{IconButton as i}from"../IconButton/IconButton.js";import{List as n}from"../List/List.js";import{useDropdown as l}from"../../../hooks/useDropdown.js";
/**
 * 아이콘 버튼과 드롭다운 목록을 결합한 컴포넌트입니다.
 * 버튼 클릭 시 드롭다운 목록이 표시되며, 키보드 탐색이 가능합니다.
 *
 * @component
 *
 * @param {Object} props
 * @param {SystemIconName} props.icon - 버튼에 표시될 아이콘
 * @param {boolean} [props.disabled=false] - 버튼 비활성화 여부를 지정합니다
 * @param {('sm'|'md'|'lg')} [props.size='sm'] - 버튼의 크기
 * @param {('left'|'right')} [props.align='left'] - 드롭다운 목록의 정렬 방향
 * @param {Item[]} props.items - 드롭다운 목록에 표시될 항목들 ({key, value, leadingIcon}[])
 * @param {Item} props.selectedItem - 현재 선택된 항목
 * @param {(item: Item) => void} props.onItemClick - 항목 선택 시 실행될 콜백 함수
 *
 * @example
 * ```tsx
 * const items = [
 *   { key: 1, value: '옵션 1', leadingIcon: 'settings' },
 *   { key: 2, value: '옵션 2', leadingIcon: 'trash' }
 * ];
 *
 * <IconButtonDropdown
 *   icon="more"
 *   items={items}
 *   selectedItem={items[0]}
 *   onItemClick={(item) => console.log(item)}
 *   size="md"
 *   align="right"
 * />
 * ```
 */const a=({icon:a,items:m,selectedItem:r,onItemClick:c,size:d="sm",align:u="left",disabled:p=!1})=>{const{isListOpen:y,ref:f,focusedIndex:I,handleItemClick:g,toggleListOpen:h,handleKeyDown:w}=l({items:m,onItemClick:c});/*#__PURE__*/
return e("div",{"data-testid":"design-system-icon-button-dropdown",className:"relative w-fit outline-none",ref:f,onKeyDown:w,tabIndex:0,children:[
/*#__PURE__*/t(i,{onClick:h,size:d,className:"outline-none",disabled:p,children:/*#__PURE__*/t(s,{name:a,className:o(p&&"text-w-gray-300")})}),y&&/*#__PURE__*/t("div",{"data-testid":"design-system-icon-button-dropdown--list-container",className:o("absolute -bottom-2 z-40 translate-y-full transform transition-all","right"===u?"right-0":"left-0 "),children:/*#__PURE__*/t(n.Root,{className:"max-h-full min-w-40 overflow-y-visible",children:m.map(((e,o)=>/*#__PURE__*/t(n.Item,{text:e.value,leadingIcon:e.leadingIcon,onClick:()=>g(e),selected:e.key===(null==r?void 0:r.key),isFocused:o===I},e.key)))})})]})};export{a as IconButtonDropdown};
